<template>
    <li>
        <template v-if="modelValue.details.child.value.length > 0">
            <button @click="toggle" type="button" class="pt-5 pb-2 px-4 text-gray-800 inline-block text-lg font-semibold">
                {{ modelValue.details.label }}
            </button>
            <menu-secondary v-if="modelValue.details.toggle" :modelValue="modelValue.details.child.value" v-model="modelValue.details.child.value"></menu-secondary>
        </template>
        <template v-else>
            <a class="py-5 px-4 font-bold text-gray-800 inline-block" :href="modelValue.details.link" v-text="modelValue.details.label"></a>
        </template>
    </li>
</template>


<script setup>
import { defineProps, defineEmits } from 'vue';
import MenuSecondary from "./MenuSecondary.vue";


const props = defineProps({
    modelValue: {
        type: Object,
    }
});

const emit = defineEmits(['update:modelValue']);

const toggle = () => {
    const temp = { ...props.modelValue };
    temp.details.toggle = !temp.details.toggle;
    emit('update:modelValue', temp);
};
</script>

<style scoped>
</style>
